import APICustomPages from "@/api/modules/customPages";

const state = () => ({
  customPagesList: [],
  customPage: null,
});

export default {
  namespaced: true,
  state,
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    },
  },
  actions: {
    getPages({ commit }, lang) {
      return APICustomPages.getPages(lang).then((response) => {
        const data = (response && response.data) || {};
        commit("SET_DATA", { type: "customPagesList", data: data.pages || [] });
      });
    },
    getPage({ commit }, { lang, alias }) {
      return APICustomPages.getPage(lang, alias).then((response) => {
        const data = (response && response.data) || {};
        commit("SET_DATA", { type: "customPage", data: data.page || null });
        return data.page || null;
      });
    },
    clearPage({ commit }) {
      commit("SET_DATA", { type: "customPage", data: null });
    },
    upsertPage(_, data) {
      return APICustomPages.upsertPage(data);
    },
    deletePage(_, { lang, alias }) {
      return APICustomPages.deletePage(lang, alias);
    },
    uploadImage(_, payload) {
      return APICustomPages.uploadImage(payload);
    },
  },
};
